import $ from 'jquery';
import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiper from 'swiper/bundle';

window.$ = $;
window.gsap = gsap;
window.Swiper = Swiper;

// breakpoints for every template: .matches for the current state, addEventListener('change', …) to react.
// app.js is a module and runs after the inline {% js %} blocks, so use them inside DOMContentLoaded there
window.mediaQuery768 = window.matchMedia('(min-width: 768px)');
window.mediaQuery1199 = window.matchMedia('(max-width: 1199px)');
window.mediaQuery1200 = window.matchMedia('(min-width: 1200px)');

gsap.registerPlugin(ScrollTrigger);

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!reduceMotion) {
    window.lenis = new Lenis();

    // keep GSAP's ScrollTrigger in sync with Lenis's smooth scroll
    lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
}

//ScrollReveal / Inview
document.addEventListener("DOMContentLoaded", function(event) {
    // observe each kompetenz entry and prozess step individually: on mobile the stacked
    // .row-entries block can be taller than 5x the viewport, so a 0.2
    // threshold on the whole container would never fire
    const revealTargets = document.querySelectorAll('h1, h2, h3, .element, .element-kompetenzen .entry, .element-prozess .step, .element-boxen .entry');

    if (!('IntersectionObserver' in window)) {
        revealTargets.forEach(el => el.classList.add('in-view'));
    } else {
        const revealObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('in-view');
                    revealObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.2 });

        revealTargets.forEach(el => revealObserver.observe(el));
    }
});